import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 },
    direction: { type: String, default: "up" } // up, down, left, right
  }

  connect() {
    // Set initial state
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"

    // Set initial transform based on direction
    const offset = "30px"
    switch (this.directionValue) {
      case "up":
        this.element.style.transform = `translateY(${offset})`
        break
      case "down":
        this.element.style.transform = `translateY(-${offset})`
        break
      case "left":
        this.element.style.transform = `translateX(${offset})`
        break
      case "right":
        this.element.style.transform = `translateX(-${offset})`
        break
    }

    // Create observer
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.element.style.opacity = "1"
              this.element.style.transform = "translate(0, 0)"
            }, this.delayValue)

            // Stop observing after animation
            this.observer.unobserve(this.element)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
      }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
